import React from 'react';
import Link from 'next/link';
import {useLoader} from 'context/loaderContext';

interface ISearchCategoriesProps {
  categories: any;
}

const PopularCategories: React.FC<ISearchCategoriesProps> = ({categories}) => {
  const {setShowLoader} = useLoader();
  return (
    <div className="mb-6">
      <header className="poppins-semibold font-lg">Popular categories</header>
      <div className="flex flex-wrap">
        {categories
          .filter(category => category.popular)
          .map(({id, name}) => (
            <Link key={id} href={`/categories/${id}`}>
              <a className="bg-primary py-1 px-3 overflow-hidden mr-2 mt-2 rounded-lg " onClick={() => setShowLoader(true)}>
                <p className="text-white poppins-semibold font-sm">{name}</p>
              </a>
            </Link>
          ))}
      </div>
    </div>
  );
};

const OtherCategories: React.FC<ISearchCategoriesProps> = ({categories}) => {
  const {setShowLoader} = useLoader();
  return (
    <>
      <header className="poppins-semibold font-lg">All categories</header>
      <div className="flex flex-col mt-1">
        {categories
          .filter(category => !category.popular)
          .map(({id, name}) => (
            <Link key={id} href={`/categories/${id}`}>
              <a className="grayBottomBorder py-3" onClick={() => setShowLoader(true)}>
                <p className="poppins-medium font-sm">{name}</p>
              </a>
            </Link>
          ))}
      </div>
    </>
  );
};

const SearchCategories: React.FC<ISearchCategoriesProps> = ({categories}) => {
  return (
    <div className="mt-6 paddingHorizontal">
      <PopularCategories categories={categories} />
      <OtherCategories categories={categories} />
    </div>
  );
};

export default SearchCategories;
